import { render } from "./TelaCarregamento.vue?vue&type=template&id=63dca60a&scoped=true"
import script from "./TelaCarregamento.vue?vue&type=script&lang=js"
export * from "./TelaCarregamento.vue?vue&type=script&lang=js"

import "./TelaCarregamento.vue?vue&type=style&index=0&id=63dca60a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dca60a"]])

export default __exports__